import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { Layout } from "@/components/Layout";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Reports from "@/pages/Reports";
import ReportCreate from "@/pages/ReportCreate";
import ReportDetail from "@/pages/ReportDetail";
import Approval from "@/pages/Approval";
import Workshop from "@/pages/Workshop";
import Vehicles from "@/pages/Vehicles";
import Admin from "@/pages/Admin";
import Styleguide from "@/pages/Styleguide";

function Protected({ children, roles }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading || user === null)
    return <div className="flex min-h-screen items-center justify-center text-sm text-slate-400">Memuat…</div>;
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

function LoginRoute() {
  const { user, loading } = useAuth();
  if (loading || user === null) return null;
  if (user) return <Navigate to="/" replace />;
  return <Login />;
}

function App() {
  return (
    <div className="App">
      <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/styleguide" element={<Styleguide />} />
            <Route path="/login" element={<LoginRoute />} />
            <Route
              element={
                <Protected>
                  <Layout />
                </Protected>
              }
            >
              <Route path="/" element={<Dashboard />} />
              <Route path="/reports" element={<Reports />} />
              <Route path="/reports/new" element={<ReportCreate />} />
              <Route path="/reports/:id/edit" element={<ReportCreate />} />
              <Route path="/reports/:id" element={<ReportDetail />} />
              <Route
                path="/approval"
                element={
                  <Protected roles={["admin", "approver"]}>
                    <Approval />
                  </Protected>
                }
              />
              <Route
                path="/workshop"
                element={
                  <Protected roles={["admin", "technician", "approver"]}>
                    <Workshop />
                  </Protected>
                }
              />
              <Route path="/vehicles" element={<Vehicles />} />
              <Route
                path="/admin"
                element={
                  <Protected roles={["admin"]}>
                    <Admin />
                  </Protected>
                }
              />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
